import * as React from "react"
import { type ReportKind } from "@digits-graphql/frontend/graphql-bearer"
import { type StatementSize } from "src/frontend/components/Shared/Layout/Components/Statements/shared"
import { ComponentSize } from "src/frontend/components/Shared/Layout/ComponentSize"

/*
  CONTEXTS
*/

interface StatementContextProps {
  kind?: ReportKind
  size?: StatementSize
  componentSize: ComponentSize
}

export const StatementContext = React.createContext<StatementContextProps>({
  componentSize: ComponentSize.Large,
})

export function useStatementSize() {
  return React.useContext(StatementContext)?.size
}

export function useStatementKind() {
  return React.useContext(StatementContext)?.kind
}

export function useStatementComponentSize() {
  return React.useContext(StatementContext).componentSize
}
